var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnalyticsTemplate',{attrs:{"page-title":"桥梁VHF统计","chart-type":"vhf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }